import React from "react";
import LandUseField from "./LandUseField"

function LandUse({countryAnswers}){
	return(<div className="question-grouping">
				<h3>Land Use Breakdown</h3>
				<div className="clearfix">
					<table style={{width:"100%", float:"left"}}>
						<thead>
							<tr>
								<th>Land Use</th>
								<th>Land Area (%)</th>
							</tr>
						</thead>
						<tbody>
							<LandUseField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Agricultural Land"} 
							year={countryAnswers.answerKeyValues['agricultural_land_year']} 
							value={countryAnswers.answerKeyValues['agricultural_land']} sourceRef={countryAnswers.answerKeyValues['agricultural_land_sources']} />
							<LandUseField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Arable Land"} 
							year={countryAnswers.answerKeyValues['arable_land_year']} 
							value={countryAnswers.answerKeyValues['arable_land']} sourceRef={countryAnswers.answerKeyValues['arable_land_sources']} />
							<LandUseField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Permanent Crops"} 
							year={countryAnswers.answerKeyValues['permanent_crops_year']} 
							value={countryAnswers.answerKeyValues['permanent_crops']} sourceRef={countryAnswers.answerKeyValues['permanent_crops_sources']} />
							<LandUseField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Permanent Pasture"} 
							year={countryAnswers.answerKeyValues['permanent_pasture_year']} 
							value={countryAnswers.answerKeyValues['permanent_pasture']} sourceRef={countryAnswers.answerKeyValues['permanent_pasture_sources']}/>
						</tbody>
					</table>
				</div>
			</div>);
}
export default LandUse;